/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/core-client/js/core-client/utils/ClassFactory'
], function(
	ClassFactory
) {

	class LegacyBoardModule {

		constructor(props) {
			props = props || {};
			this._loader = props.loader || ClassFactory;
			this.logger = props.logger;
		}

		load(module) {
			var path = module.path || module;
			return this._loader.loadModule(path)
				.then((ModuleClass) => {
					return {
						template: ModuleClass.getTemplate,
						module: ModuleClass
					};
				})
				.catch((error) => {
					this.logger.warn(`[LegacyBoardModule]: attempted to load module "${path} and failed"`, error);
					throw error;
				});
		}
	}

	return LegacyBoardModule;
});
